export default "__VITE_ASSET__BeCqWFaE__"